import PropTypes from "prop-types";
import { cn } from "@/lib/utils";

const STATUS_STYLES = {
  connected: "bg-emerald-50 text-emerald-700",
  not_connected: "bg-amber-50 text-amber-700",
  not_configured: "bg-slate-100 text-slate-600",
  processing: "bg-indigo-50 text-indigo-700",
};

export function SourceStatusBadge({ status, label }) {
  const style = STATUS_STYLES[status] || STATUS_STYLES.not_configured;
  return (
    <span
      className={cn(
        "rounded-full px-1.5 py-0.5 text-[10px] font-medium shrink-0 max-w-[9rem] truncate",
        style,
      )}
      title={label || undefined}
    >
      {label}
    </span>
  );
}

SourceStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
};

export default SourceStatusBadge;
